module.exports = __webpack_public_path__ + "img/f4f57bbc-8a7c-4ec1-8969-0f3eca643782.bafc8a61.jpg";